import { createI18n } from 'vue-i18n';
import { daDK } from '~/app/locales/da-DK/daDK';
import { enUS } from '~/app/locales/en-US/enUS';
import { esES } from '~/app/locales/es-ES/esES';
import { frFR } from '~/app/locales/fr-FR/frFR';
import { itIT } from '~/app/locales/it-IT/itIT';
import { ptPT } from '~/app/locales/pt-PT/ptPT';

// ERROR
import { daDK_error } from '~/app/locales/da-DK/daDK_error';
import { enUS_error } from '~/app/locales/en-US/enUS_error';
import { esES_error } from '~/app/locales/es-ES/esES_error';
import { frFR_error } from '~/app/locales/fr-FR/frFR_error';
import { itIT_error } from '~/app/locales/it-IT/itIT_error';
import { ptPT_error } from '~/app/locales/pt-PT/ptPT_error';

// COUNTRY
import { daDK_country } from '~/app/locales/da-DK/daDK_country';
import { enUS_country } from '~/app/locales/en-US/enUS_country';
import { esES_country } from '~/app/locales/es-ES/esES_country';
import { frFR_country } from '~/app/locales/fr-FR/frFR_country';
import { itIT_country } from '~/app/locales/it-IT/itIT_country';
import { ptPT_country } from '~/app/locales/pt-PT/ptPT_country';

function determineLocale() {
  const acceptLanguageHeader = useRequestHeaders(['accept-language'])['accept-language'];
  if (typeof document !== 'undefined' && window !== undefined) {
    // @ts-ignore
    return navigator.language || navigator.userLanguage;
  }
  if (typeof window !== 'undefined') {
    return window.navigator.language;
  }

  if (typeof acceptLanguageHeader !== 'undefined') {
    return acceptLanguageHeader?.split(',')?.[0] ?? undefined;
  }
  return undefined;
}

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: determineLocale(),
    fallbackLocale: 'en-US',
    messages: {
      // TODO lazy load languages
      ['en-US']: { ...enUS, ...enUS_error, ...enUS_country },
      ['da-DK']: { ...daDK, ...daDK_error, ...daDK_country },
      ['fr-FR']: { ...frFR, ...frFR_error, ...frFR_country },
      ['fr']: { ...frFR, ...frFR_error, ...frFR_country },
      ['it-IT']: { ...itIT, ...itIT_error, ...itIT_country },
      ['es-ES']: { ...esES, ...esES_error, ...esES_country },
      ['pt-PT']: { ...ptPT, ...ptPT_error, ...ptPT_country },
    },
    numberFormats: {
      'en-US': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          notation: 'standard',
          currencyDisplay: 'symbol',
        },
      },
      fr: {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
      'fr-FR': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
      'es-ES': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
      'pt-PT': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
      'it-IT': {
        currency: {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
        },
      },
    },
  });

  vueApp.use(i18n);
});
